<script>
import formcombobox from "@/router/views/FormComponet/formcombobox.vue";
import Layout from "@/router/layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Drawer from "vue-simple-drawer";
import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import StrBirimKontrolTutarlari from "@/models/StrBirimKontrolTutarlari";
import BirimSecimi from "@/router/views/FormComponet/BirimSecimiAnaBirim.vue";

import AddEdit from "./AddEdit.vue";
export default {
  mixins: [Api, Sabit, StrBirimKontrolTutarlari],
  page: {
    title: "%10 Veri Girişi",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    Drawer,
    Layout,
    PageHeader,
    AddEdit,
    formcombobox,
    BirimSecimi
  },
  data() {
    return {
      title: this.$t("StrBirimKontrolTutarlari.Title"),
      items: [
        {
          text: this.$t("StrBirimKontrolTutarlari.Page.Anasayfa"),
          href: "/",
        },
        {
          text: this.$t("StrBirimKontrolTutarlari.Page.UstMenu"),
          active: true,
        },
        {
          text: this.$t("StrBirimKontrolTutarlari.Title"),
          active: true,
        },
      ],
      DefaultPage: 1,
      Page: {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      },
      FilitrelemePenceresi: false,
      TableData: {},
      DataUpdate: "",
      AddEdit: "",
      DonemCombobox: [],
      BirimIdCombobox: [],
      HarcamaTipIdCombobox: [],
      IhaleTipiIdCombobox: [],
      AyCombobox: [],
      Filter: {
        Donem: "",
        BirimId: null,
        HarcamaTipId: "",
        IhaleTipiId: "",
        Ay: "",
      },
    };
  },
  validations: {
    Filter: {
      Donem: {},
      BirimId: {},
      HarcamaTipId: {},
      IhaleTipiId: {},
      Ay: {},
    },
  },
  methods: {
    Get() {
      let Filter = "";
      if (this.Filter.Donem!=null && this.Filter.Donem!="") {Filter = Filter + "&Donem="+this.Filter.Donem; }
      if (this.Filter.BirimId!=null && this.Filter.BirimId!=""  && this.Filter.BirimId!="1") {Filter = Filter + "&BirimId="+this.Filter.BirimId; }
      if (this.Filter.HarcamaTipId!=null && this.Filter.HarcamaTipId!="") {Filter = Filter + "&HarcamaTipId="+this.Filter.HarcamaTipId; }
      if (this.Filter.IhaleTipiId!=null && this.Filter.IhaleTipiId!="") {Filter = Filter + "&IhaleTipiId="+this.Filter.IhaleTipiId; }
      if (this.Filter.Ay!=null && this.Filter.Ay!="") {Filter = Filter + "&Ay="+this.Filter.Ay; }

      console.log(Filter)

      this.ActionsFilterGet({ Service: "StrBirimKontrolTutarlari", Page: this.Page, Filter: Filter }).then((res) => {
        this.TableData = res.Data;
        this.Page.PageDataSize = res.TotalCount;
      });
    },
    rightDrawer() {
      this.FilitrelemePenceresi = !this.FilitrelemePenceresi;
    },
  },
  created() {
    this.ActionsSabitGet(1548).then((res) => {
      this.HarcamaTipIdCombobox = res.Data;
    });
    this.ActionsSabitGet(1552).then((res) => {
      this.IhaleTipiIdCombobox = res.Data;
    });
    this.ActionsSabitGet(77).then((res) => {
      this.AyCombobox = res.Data;
    });
    let Page = {
      PageNumber: "1",
      PageSize: "9999",
    };
    this.ActionsFilterGet({ Service: "StrPerfDonem", Page: Page, Filter: "&Approval=true" }).then((res) => {
      for (var i = 0; i < res.Data.length; i++) {
        this.DonemCombobox.push({ Id: res.Data[i].YilBas, Value: res.Data[i].YilBas });
      }
      const _ = require("lodash");
      this.DonemCombobox = _.keyBy(this.DonemCombobox, "Id");
    });
    this.ActionsGet({ Service: "OBirim", Page: Page }).then((res) => {
      for (var i = 0; i < res.Data.length; i++) {
        this.BirimIdCombobox.push({ Id: res.Data[i].Id, Value: res.Data[i].BirimAdi });
      }
    });
  },
};
</script>

<template>
  <Loader>
    <Layout>
      <PageHeader :title="title" :items="items" />

      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="row mb-2">
                <div class="col-sm-4"></div>
                <div class="col-sm-8">
                  <div class="text-sm-end">
                    <button type="button" class="btn btn-secondary btn-rounded mb-2 me-2" @click="rightDrawer"><i class="mdi mdi-text-search me-1"></i> {{ $t("StrBirimKontrolTutarlari.Page.Filtreleme") }}</button>
                    <button type="button" class="btn btn-primary btn-rounded mb-2 me-2" v-b-modal.StrBirimKontrolTutarlari @click="(DataUpdate = StrBirimKontrolTutarlariData), (AddEdit = 'Add')"><i class="mdi mdi-plus me-1"></i> {{ $t("StrBirimKontrolTutarlari.Page.YeniKayitEkle") }}</button>
                  </div>
                </div>
              </div>

              <div class="table-responsive">
                <table class="table mb-0">
                  <thead class="table-light">
                    <tr>
                      <th>{{ $t("StrBirimKontrolTutarlari.Table.Donem") }}</th>
                      <th>{{ $t("StrBirimKontrolTutarlari.Table.BirimAdi") }}</th>
                      <th>{{ $t("StrBirimKontrolTutarlari.Table.HarcamaTipiAdi") }}</th>
                      <th>{{ $t("StrBirimKontrolTutarlari.Table.Tutar") }}</th>
                      <th style="width: 85px; text-align: center; vertical-align: middle;">{{ $t("StrBirimKontrolTutarlari.Table.Islem") }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="VeriGirisiVerileri in TableData" :key="VeriGirisiVerileri.Id">
                      <th scope="row">{{ VeriGirisiVerileri.Donem }}</th>
                      <td>{{ VeriGirisiVerileri.BirimAdi }}</td>
                      <td>{{ VeriGirisiVerileri.HarcamaTipiAdi }}</td>
                      <td>{{ VeriGirisiVerileri.Tutar }}</td>
                      <td style="width: 85px; text-align: center; vertical-align: middle;">

                        <b-button-group>
                          <b-button variant="danger" @click="Delete('StrBirimKontrolTutarlari', VeriGirisiVerileri.Id)"><i class="fas fa-trash-alt"></i></b-button>
                        </b-button-group>
                        
                      </td>
                    </tr>
                  </tbody>
                </table>
                <br />
                <b-pagination class="pagination pagination-rounded justify-content-end mb-2" v-model="DefaultPage" :total-rows="Page.PageDataSize" :per-page="Page.PageSize" aria-controls="my-table" @input="ChangePage(DefaultPage)"> </b-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>

      <AddEdit :Id="DataUpdate" :AddEdit="AddEdit" @TableUpdate="Get()" />
      

      <Drawer @close="rightDrawer" :align="'right'" :closeable="true" :maskClosable="true" :zIndex="1002">
        <div style="width: 400px;" v-if="FilitrelemePenceresi">
          <div class="offcanvas-header">
            <h5 class="offcanvas-title" id="offcanvasExampleLabel">
              {{ $t("StrBirimKontrolTutarlari.Filtreleme.Title") }}
            </h5>
          </div>
          <div >
            {{ $t("StrBirimKontrolTutarlari.Filtreleme.Content") }}
            <div class="mb-3">
              <formcombobox
                :FormDataType="{
                  FieldName: 'Donem',
                  Field: 'combobox',
                  FieldTitle: $t('StrBirimKontrolTutarlari.Filtreleme.Donem'),
                  ComboDataArray: DonemCombobox,
                }"
                :Value="Filter.Donem"
                :v="$v.Filter.Donem"
                @input="Filter.Donem = $event"
              />
            </div>
            <div class="mb-3">

              
                  <BirimSecimi
                    :title="$t('StrBirimKontrolTutarlari.Filtreleme.BirimId')"
                    :sutun="'0'" 
                    :title_position="'mb-3'"
                    :selected="Filter.BirimId"
                    :YetkiKontrol="1"
                    :labels_lg="'3'"  
                    :multiple="false"
                    :BirimTipId="null"
                    @Secilmis_Idler="Filter.BirimId=$event"
                  />
    


            </div>
            <div class="mb-3">
              <formcombobox
                :FormDataType="{
                  FieldName: 'HarcamaTipId',
                  Field: 'combobox',
                  FieldTitle: $t('StrBirimKontrolTutarlari.Filtreleme.HarcamaTipId'),
                  ComboDataArray: HarcamaTipIdCombobox,
                }"
                :Value="Filter.HarcamaTipId"
                :v="$v.Filter.HarcamaTipId"
                @input="Filter.HarcamaTipId = $event"
              />
            </div>
            <div class="mb-3">
              <formcombobox
                :FormDataType="{
                  FieldName: 'IhaleTipiId',
                  Field: 'combobox',
                  FieldTitle: $t('StrBirimKontrolTutarlari.Filtreleme.IhaleTipiId'),
                  ComboDataArray: IhaleTipiIdCombobox,
                }"
                :Value="Filter.IhaleTipiId"
                :v="$v.Filter.IhaleTipiId"
                @input="Filter.IhaleTipiId = $event"
              />
            </div>
            <div class="mb-3">
              <formcombobox
                :FormDataType="{
                  FieldName: 'Ay',
                  Field: 'combobox',
                  FieldTitle: $t('StrBirimKontrolTutarlari.Filtreleme.Ay'),
                  ComboDataArray: AyCombobox,
                }"
                :Value="Filter.Ay"
                :v="$v.Filter.Ay"
                @input="Filter.Ay = $event"
              />
            </div>

            <b-button @click="Get(),rightDrawer()" class="btn btn-primary" variant="primary">{{ $t("StrBirimKontrolTutarlari.Filtreleme.Button") }}</b-button>
          </div>
        </div>
      </Drawer>
    </Layout>
  </Loader>
</template>
